import Sudoku from "@shared/ui/Sudoku"
import type { CompanyDetailsProps } from "@site-types/components/companyDetails"
import CompanyDetailsTable from "./CompanyDetailsTable"
import CompanyStory from "./CompanyStory"
import CompanyTimeline from "./CompanyTimeline"
export function CompanyDetails({ data }: CompanyDetailsProps) {
  return (
    <div className="relative">
      <CompanyStory />
      <CompanyTimeline historyItems={data.companyHistory} />
      <CompanyDetailsTable />
      <Sudoku />
    </div>
  )
}

export default CompanyDetails
